import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useState, useCallback } from 'react';
import { Modal } from '../Modal';
import { useTranslation } from '@ciam/i18n';
export const ModalContext = createContext(undefined);
export const ModalProvider = ({ children }) => {
    const { t } = useTranslation('ui');
    const [modalState, setModalState] = useState({
        isOpen: false,
        type: undefined,
        title: '',
        description: [],
        addContent: undefined,
        hideButtons: false,
        onConfirm: undefined,
        onCancel: undefined,
    });
    const { isOpen, type, title, description, addContent, hideButtons, onConfirm, onCancel } = modalState;
    const openModal = useCallback(({ type, title: customTitle, description, addContent, hideButtons = false, onConfirm, onCancel, }) => {
        let modalTitle = customTitle || '';
        if (!customTitle && type) {
            switch (type) {
                case 'error':
                    modalTitle = t('modal.title.type.error');
                    break;
                case 'alert':
                    modalTitle = t('modal.title.type.alert');
                    break;
                case 'success':
                    modalTitle = t('modal.title.type.success');
                    break;
                case 'warning':
                    modalTitle = t('modal.title.type.warning');
                    break;
            }
        }
        setModalState({
            isOpen: true,
            type,
            title: modalTitle,
            description: description || [],
            addContent,
            hideButtons,
            onConfirm,
            onCancel,
        });
    }, [t]);
    const handleConfirm = useCallback(() => {
        if (modalState.onConfirm) {
            modalState.onConfirm();
        }
        setModalState({
            isOpen: false,
            type: undefined,
            title: '',
            description: [],
            hideButtons: false,
            onConfirm: undefined,
            onCancel: undefined,
        });
    }, [modalState]);
    const handleCancel = useCallback(() => {
        if (modalState.onCancel) {
            modalState.onCancel();
        }
        setModalState({
            isOpen: false,
            type: undefined,
            title: '',
            description: [],
            hideButtons: false,
            onConfirm: undefined,
            onCancel: undefined,
        });
    }, [modalState]);
    const contextValue = {
        isOpen,
        type,
        title,
        description,
        addContent,
        hideButtons,
        openModal,
        onConfirm,
        onCancel,
        handleConfirm,
        handleCancel,
    };
    return (_jsxs(ModalContext.Provider, { value: contextValue, children: [children, isOpen && _jsx(Modal, {})] }));
};
//# sourceMappingURL=Modal.context.js.map